import {
  DBxEvent,
  PolylineGeometry,
  PolygonGeometry,
  LineSegment
  } from "cartovista";
  import {queryBaseLayer} from "../utils/ServerRequests";

    //TODO: Merger avec ZoomLayeringServer (pratiquement le même code)
    export default class ZoomLayering {
      constructor(layerConfig) {
        this._map = window.cartovista.getMap(C.MAP.ID);
        this._map.addEventListener(this._map.EVENTS.EXTENT_CHANGED, _.debounce(this._onMapExtentOrLayerVisibleChanged, 250), this);
        this._layerConfig = layerConfig;
        this._baseLayerId = layerConfig.ZOOM_LAYERING.BASE_LAYER_ID;
        this._genLayerId = layerConfig.LAYER_ID;
        this._switchScale = layerConfig.ZOOM_LAYERING.SWITCH_SCALE;
        this._regroupRequests = layerConfig.ZOOM_LAYERING.REGROUP_REQUESTS;
        this._maxFeaturesPerRequest = 500; //1000 is the max allowed by the server
        this._pendingRequestFeatures = [];
        //promise that waits for layer created in map
        new Promise(function(resolve, reject) {
            if (this._map.getLayer(layerConfig.LAYER_ID) == null) {
                window.cartovista.addOneTimeEventListener(layerConfig.LAYER_ID + "_layerCreated", resolve);
            } else {
                resolve();
            }
        }.bind(this)).then(function() {
            this._layer = this._map.getLayer(this._layerConfig.LAYER_ID);
            this._layer.addEventListener(this._layer.EVENTS.VISIBLE_CHANGED, this._onMapExtentOrLayerVisibleChanged, this);
        }.bind(this));
      }


    _onMapExtentOrLayerVisibleChanged(e) {
        if (this._layer && this._layer.visible) {
            if (this._map.mapScale < this._switchScale) {
                this._replaceGenByBaseGeometries();
            } else {
                this._replaceBaseByGenGeometries();
            }
        }
    };

    _replaceBaseByGenGeometries() {
        //get base features list in the current map extent
        var features = this._getBaseFeaturesByExtent(this._map.extent);
        //handle only features with zoomLayeringState == undefined or "base", else they are already replaced
        var featuresToSwitch = _.filter(features, function(feature) {
            return typeof feature.zoomLayeringState == "undefined" || feature.zoomLayeringState == "base";
        });
        //switch features to gen geometry
        this._switchBaseToGenGeometry(featuresToSwitch);
    };

    _replaceGenByBaseGeometries() {
        //get gen features list in the current map extent
        var features = this._getGenFeaturesByExtent(this._map.extent);
        var featuresToSwitch = [];
        var featuresToRequest = [];
        _.forEach(features, function(feature) {
            //set zoomLayeringState to base here to prevent redundant requests in case of
            //multiples zooms in and zooms out before the request responses arrived
            feature.zoomLayeringState = "base";
            if (feature._geometries.length > 1) {
                //feature ready to switch because base geometry was already added
                featuresToSwitch.push(feature);
            } else {
                //feature's base geometry is not added already
                featuresToRequest.push(feature);
            }
        });
        //switch features that base geometry is already added
        this._switchGenToBaseGeometry(featuresToSwitch);
        if (featuresToRequest.length) {
            if (this._regroupRequests) {
                _.forEach(_.chunk(featuresToRequest, this._maxFeaturesPerRequest), function(chunk) {
                    this._layerConfig.ZOOM_LAYERING.QUERY_EXPRESSION.QUERIES[0].OPERATOR = "IN";
                    this._layerConfig.ZOOM_LAYERING.QUERY_EXPRESSION.QUERIES[0].VALUE = _.map(chunk, "id");
                    this._requestBaseFeatures(chunk);
                }.bind(this));
            } else {
                _.forEach(featuresToRequest, function(feature) {
                    this._layerConfig.ZOOM_LAYERING.QUERY_EXPRESSION.QUERIES[0].OPERATOR = "=";
                    this._layerConfig.ZOOM_LAYERING.QUERY_EXPRESSION.QUERIES[0].VALUE = feature.id;
                    this._requestBaseFeatures([feature]);
                }.bind(this));
            };
        }
    };

    //request baseFeatures then switch geometry
    _requestBaseFeatures(featuresToRequest) {
        queryBaseLayer(this._layerConfig, this._layerConfig.ZOOM_LAYERING.QUERY_EXPRESSION, {"getFromCache": this._regroupRequests ? false : true})
            .then(function(response) {
                this._addBaseGeometryToFeatures(featuresToRequest, response.features);
                this._switchGenToBaseGeometry(featuresToRequest);
            }.bind(this));
    };

    _addBaseGeometryToFeatures(features, featuresData) {
        var layerType = this._map.getLayer(this._genLayerId).layerType,
            baseLayerIdField = this._layerConfig.ZOOM_LAYERING.QUERY_EXPRESSION.QUERIES[0].FIELD;

        switch (layerType) {
            case "POLYLINE":
                _.forEach(features, function(feature, idx) {
                    feature.addGeometries(this.createPolylineGeometry(_.find(featuresData, function(featureData) {
                        return featureData.attributes[baseLayerIdField] == feature.id;
                    }), undefined, true));
                }.bind(this));
                break;
            case "POLYGON":
                _.forEach(features, function(feature, idx) {
                    feature.addGeometries(this.createPolygonGeometry(_.find(featuresData, function(featureData) {
                        return featureData.attributes[baseLayerIdField] == feature.id;
                    }), undefined, true));
                }.bind(this));
                break;
            default:
                throw new Error("ZoomLayering._addBaseGeometryToFeatures() - layerType: " + layerType + " is invalid.");
        };
    };

    _getGenFeaturesByExtent(extent) {
        var features;
        this._layer.getFeaturesByExtent(extent, function(result) {
            //handle only features with zoomLayeringState == undefined or "gen", else they are already replaced
            features = _.filter(result.features, function(feature) {
                return typeof feature.zoomLayeringState == "undefined" || feature.zoomLayeringState == "gen" && feature.visible && !feature.filteredOut;
            });
        });
        return features;
    };

    _getBaseFeaturesByExtent(extent) {
        var features;
        this._layer.getFeaturesByExtent(extent, function(result) {
            features = _.filter(result.features, function(feature) {
                //handle only features with zoomLayeringState == undefined or "base", else they are already replaced
                return typeof feature.zoomLayeringState == "undefined" || feature.zoomLayeringState == "base" && feature.visible && !feature.filteredOut;
            });
        });
        return features;
    };

    _switchGenToBaseGeometry(features) {
        if (Array.isArray(features) && features.length > 0) {
            _.forEach(features, function(feature) {
                feature.zoomLayeringState = "base";
                feature._setCurrentGeometry(feature._geometries[1]);
            });
            this._layer.dispatchEvent(new DBxEvent(this._layer.EVENTS.CONTENT_CHANGED));
        }
    };

    _switchBaseToGenGeometry(features) {
        if (Array.isArray(features) && features.length > 0) {
            _.forEach(features, function(feature) {
                feature.zoomLayeringState = "gen";
                feature._setCurrentGeometry(feature._geometries[0]);
            });
            this._layer.dispatchEvent(new DBxEvent(this._layer.EVENTS.CONTENT_CHANGED));
        }
    };

    createPolylineGeometry(featureData, projection, useTypedArray) {
        var polylineGeometry = new PolylineGeometry(projection ? projection : window.cartovista.externalInterface.map.currentCoordinateSystem.projection);
        if (featureData.geometry) {
            for (var i=0, g=featureData.geometry.length; i<g ; i++) {
                var path = [featureData.geometry[i][0], featureData.geometry[i][1]];
                for (var j=2, l=featureData.geometry[i].length; j<l; j++) {
                    path.push(path[j-2] - featureData.geometry[i][j]);
                }
                var lineSegment = new LineSegment();
                lineSegment.coordinates = useTypedArray ? new Int32Array(path) : path;
                polylineGeometry.addLineString([lineSegment]);
            }
        }
        return polylineGeometry;
    };

    createPolygonGeometry(featureData, projection, useTypedArray) {
        var polygonGeometry = new PolygonGeometry(projection ? projection : window.cartovista.externalInterface.map.currentCoordinateSystem.projection);
        if (featureData.geometry) {
            for (var i=0, g=featureData.geometry.length; i<g ; i++) {
                var ring = [featureData.geometry[i][0], featureData.geometry[i][1]];
                for (var j=2, l=featureData.geometry[i].length; j<l; j++) {
                    ring.push(ring[j-2] - featureData.geometry[i][j]);
                }
                var lineSegment = new LineSegment();
                lineSegment.coordinates = useTypedArray ? new Int32Array(ring) : ring;
                polygonGeometry.addRing([lineSegment]);
            }
        }
        return polygonGeometry;
    };

  }
